// eslint-disable-next-line max-len
var MISC_FLAG_FI = 'M31,5.5H0v21H32V5.5Zm-1,2v6H14v-6ZM9,7.5v6H2v-6Zm-7,11H9v6H2Zm12,6v-6H30v6Z';

export { MISC_FLAG_FI };
//# sourceMappingURL=MISC_FLAG_FI.js.map
